import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export const useDeleteGroup = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (groupId: string) => {
			try {
				await api.delete(`/management/group/delete/${groupId}`);
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir grupo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['groups'] });
		},
	});
};
